/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function SsoSaml({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M10 12.6a2.101 2.101 0 0 1-2.013-1.5H6.6v.804a.6.6 0 0 1-1.2 0V11.1h-.9a.6.6 0 1 1 0-1.2h3.487A2.1 2.1 0 1 1 10 12.6Zm0-3a.9.9 0 1 1 0 1.8.9.9 0 0 1 0-1.8Z" clipRule="evenodd" /><path fill="currentColor" fillRule="evenodd" d="M4.4 5a3.6 3.6 0 0 1 7.2 0v.9h.4a2.6 2.6 0 0 1 2.6 2.6v5a1.6 1.6 0 0 1-1.6 1.6H3a1.6 1.6 0 0 1-1.6-1.6v-5A2.6 2.6 0 0 1 4 5.9h.4V5Zm6 0v.9H5.6V5a2.4 2.4 0 0 1 4.8 0ZM4 7.1a1.4 1.4 0 0 0-1.4 1.4v5c0 .22.18.4.4.4h10a.4.4 0 0 0 .4-.4v-5A1.4 1.4 0 0 0 12 7.1H4Z" clipRule="evenodd" /></svg>;
}
;